import axios from "./axios-config";

export const getAllWorkshops = async (keyword, page) => {

    let { data } = await axios.get(`/super-admin/workshops?keywords=${keyword ?? ""}&page=${page}`)
    return (data);

}
export const getAllWorkshopsWithoutPaginate = async (keyword, page) => {

    let { data } = await axios.get(`/super-admin/workshops?type=all`)
    return (data);

}

export const getSingleWorkshop = async (id) => {

    let { data } = await axios.get(`/super-admin/workshops/` + id)
    return data;

}
export const deleteSingleWorkshop = async (id) => {
    let { data } = await axios.delete(`/super-admin/workshops/` + id)
    return data;
}

export const updateSingleWorkshops = async (updateData) => {

    let { data } = await axios.post(`/super-admin/workshops/${updateData.id}?_method=put`, updateData.data)
    return data;
}

export const storeSingleWorkshops = async (storeData) => {

    let { data } = await axios.post(`/super-admin/workshops`, storeData)
    return data
}


// export const getBlogWorkshops = async (data) => {
//     let { data } =  await axios.post(`/super-admin/Workshops/all/blogs`, data)
//     return data;
// }

// export const getWorkshopWorkshops = async (data) => {
//     try {
//         let response = await axios.post(`/super-admin/Blogs/all/workshops`, data)
//         return (response.data);
//     } catch (error) {
//         return (error);
//     }
// }

